import React from 'react';
import { Outlet } from 'react-router-dom';

export function My(props) {
  return <Outlet />;
}
